import { z } from "zod";

import copyJson from "./api-copy.json";

const copySchema = z.object({
  notFound: z.object({
    chemical: z.string().min(1),
    transaction: z.string().min(1),
    contact: z.string().min(1),
    contactPerson: z.string().min(1),
    order: z.string().min(1),
  }),
});

export const NOT_FOUND_MESSAGES = copySchema.parse(copyJson).notFound;
